import claimMessages from '@/modules/Claim/i18n/en'
import damageMessages from '@/modules/Damage/i18n/en'
import appointmentMessages from '@/modules/Appointment/i18n/en'
import documentMessages from '@/modules/Document/i18n/en'

export default {
  claim: { ...claimMessages },
  damage: { ...damageMessages },
  appointment: { ...appointmentMessages },
  document: { ...documentMessages },
  documentContainer: {
    title: 'Property Damage',
    upper1: 'To best process your request, we invite you to send us your quote/invoice by following the instructions below:',
    upper2: 'If your quote/invoice fits on one page, please send it to us in pdf, jpg, or png format.',
    upper3: 'If your quote/invoice contains more than one page, please combine all pages into a single file in pdf format.',
    upper4: "If you have multiple quotes, please upload them one by one by clicking the button below. Once all documents are uploaded, click 'Continue'."
  },
  // actions
  actions: {
    addDamage: 'Add',
    login: 'Login',
    select: 'Select',
    clear: 'Clean',
    continue: 'Continue',
    cancel: 'Cancel',
    import: 'Import',
    export: 'Export',
    exportAll: 'Export all',
    selectFile: 'Select file',
    search: 'Search',
    save: 'Save',
    delete: 'Delete',
    suppress: 'Delete',
    confirmAndContinue: 'Confirm and continue',
    confirmDommages: 'Validate the damage',
    goBack: 'Go back',
    addMoreDamage: 'Add damage',
    accept: 'Accept',
    confirmWithNoDamages: 'I have not suffered any damage, move on to the next step'
  },
  // common damages
  commonDamages: {
    emptyData: 'No data related to this damage was specified'
  },

  // view: addDamages
  addDamages: {
    title: 'Tell us more about your damage',
    buttonTitle: 'Add damage'
  },

  // view: multidamageList
  multidamageList: {
    delete: 'Delete',
    inputTitle: 'Please tell us the size of your room',
    inputTitleTest: 'What is the surface area (approximate)',
    inputHint: 'In square metres',
    btnContinue: 'Confirm and continue',
    btnAddDamage: 'Specify these damages',
    btnAddDamagePhotoclaim: 'Take a photo of the damage',
    btnAddDamageModal: 'Confirming this damage',
    btnAddAllDamages: 'Next',
    calculateSurfaceLink: {
      text1: 'You don’t know the surface area?',
      text2: 'We can help you calculate it',
      link: 'Calculate the surface area'
    },
    calculateSurfaceModal: {
      title: 'Calculate the area',
      input1: 'How many steps did you count across the width of the room?',
      input2: 'How many steps did you count along the length of the room?',
      inputErrorText: 'This must be a numerical value greater than 1',
      text: 'To measure your room, we need to know the width and length. To do this, we ask you to stand in a corner and from there, please walk along both sides and record the number of steps of the width and length of your room.'
    }
  },

  // view: damageMobilier
  damageMobilier: {
    search: {
      predictibles: 'Choose from our most popular categories:',
      containerInputs: 'Search our categories',
      categoryList: 'Search results',
      containerEmptyTxt1: 'Your research',
      containerEmptyTxt2: 'did not find',
      containerEmptyTxt3: 'results'
    },
    category: {
      inputTextError: 'Required fields - numerical value',
      modal1: 'Before continuing',
      modal2: 'Please check that this data is correct:',
      date: 'Purchase date',
      price: 'Purchase price',
      buttonsNextActionsTitle: 'Yes, this is correct',
      buttonsNextActionsTitleWhiteBtn: 'No, edit'
    },
    damageResultUptec: {
      title: 'The valuation of your damage will be done using this model:'
    }
  },

  // view: damageItems
  damagedItems: {
    buttonTitle: 'Next',
    defaultTitle: 'Which parts were affected?',
    defaultText: ''
  },

  // view: damagedParts
  damagedParts: {
    buttonTitle: 'Next',
    selectParts:
      'Indicate which supports were affected or if cleaning is required',
    multidamageDescription: 'Select all parts affected by the damage.',
    defaultText: '',
    defaultTextExternalDamage: 'What is the damaged item?'
  },

  // view: damageDetails
  damageDetails: {
    surfaceSmallText: 'in square meters',
    titleFileInputEnsemble:
      'Overview photos - Please stand as far away from the damage as possible',
    titleFileInputPres:
      'Close up photos - Please get as close as possible to the damage',
    errorPhoto:
      'Attach the photo in .png or .jpg or .jpeg format. No larger than 6 MB.'
  },

  // view: damagesConfirmed
  damagesConfirmed: {
    titleDamagesConfirmed: 'Summary of damage',
    photosEnsemble:
      'Overview photos - Please stand as far away from the damage as possible',
    photosPres:
      'Close up photos - Please get as close as possible to the damage'
  },

  // component: furniture
  furniture: {
    title: 'Furniture',
    empty: {
      short: 'Missing claim reference',
      long: 'In order to add damage to furniture, enter the claim reference'
    },
    kindOfProperty: 'Type of ownership',
    kindOfPropertyOptions: {
      owner: 'Owner',
      renter: 'Tenant'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    materialListBtn: 'List of equipment'
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'The postcode you entered previously is not accepted',
        body: 'Error during the action'
      },
      400: {
        title: 'Mandatory field not filled in',
        body: 'Please review the fields that are not filled in'
      },
      500: {
        title: 'Error',
        body: 'An error has occurred'
      },
      409: {
        title: 'Identification error',
        body: 'The claim already exists'
      },
      title: 'The postcode you entered previously is not accepted',
      body: 'Error during the action'
    },
    addDamage: {
      title: 'Damage created',
      body: 'The damage was created correctly'
    },
    newSinister: {
      title: 'New claim',
      body: 'The claim ID has been changed'
    },
    deleteDamage: {
      title: 'Damage removed',
      body: 'The damage has been removed correctly'
    },
    pdfDamages: {
      title: 'Report created',
      body: 'Report created correctly'
    },
    pdfMaterial: {
      title: 'Report created',
      body: 'Report created correctly'
    },
    mailPdfMaterial: {
      title: 'E-mail sent',
      body: 'Email sent correctly',
      error: {
        title: 'Invalid email',
        body: 'Please enter a correct email'
      }
    },
    moCalculation: {
      title: 'Price updated',
      body: 'Reloading the current report'
    },
    changeLanguage: {
      title: 'Change language',
      body: 'Referral'
    },
    loadSinisterOK: {
      title: 'Claim loaded',
      body: 'Update information'
    },
    loadSinisterKO: {
      title: 'Claim error',
      body: 'Error while loading claim'
    },
    paramChanged: {
      title: 'Parameter changed',
      body: 'The table will be updated automatically.'
    },
    user: {
      isRequired: {
        title: 'Missing mandatory fields',
        body: 'Please complete all fields correctly'
      },
      isEmail: {
        title: 'Wrong email',
        body: 'The email entered is not valid'
      },
      isSamePassword: {
        title: 'Please check the password',
        body: 'Passwords do not match'
      },
      createdUser: {
        title: 'User created',
        body: 'View being updated'
      },
      modifiedUser: {
        title: 'User changed',
        body: 'View being updated'
      },
      deletedUser: {
        title: 'User deleted',
        body: 'View being updated'
      },
      error: {
        400: {
          title: 'Mandatory fields are missing',
          body: 'Please check the required fields'
        },
        500: {
          title: 'Error',
          body: 'An error has occurred'
        },
        409: {
          title: 'Login error',
          body: 'User already exists'
        }
      }
    },
    images: {
      uploadError: {
        title: 'Upload error',
        text: 'Attach the photo in .png or .jpg or .jpeg format. No more than 6MB.'
      },
      inputImgError: {
        title: 'Upload error',
        text: 'An error occurred while uploading the photo. You can continue without adding photos'
      },
      postImgError: {
        title: 'Upload error',
        text: 'An error occurred while uploading the photo.'
      }
    }
  },

  // datePicker
  datePicker: {
    literal: 'Date of purchase'
  },

  // damagesTypes view
  damagesTypes: {
    titleNavbar: 'What is the origin of your damages?'
  },

  // damageValidation
  damageValidation: {
    title: 'Property damage',
    subtitle: 'Based on the information provided, we can offer an immediate compensation basis of',
    text1: 'Solution: Carry out the repairs myself',
    text2: 'According to the description of your damages, we propose the following immediate compensation:',
    text3: 'If you accept this compensation, you will receive it in the bank account used for your contributions or by check.',
    text4: 'If you refuse this compensation, an Allianz advisor will contact you within 48 hours*.',
    text5: '*Working hours and unless there are exceptional issues or circumstances beyond our control.',
    modal: {
      title: 'How this compensation is calculated',
      subtitle: 'The amicable compensation you will receive for your property damage is calculated based on the total cost of repairs. This total cost is the compensation basis and includes the cost of materials, tool rental, and compensation for the time spent on the repairs. \nIf a deductible is stipulated in your contract, it will be deducted from the compensation amount. \n\n The compensation can be paid by bank transfer within the usual time frame with your bank details, or by bank check.',
      button: 'Accept',
      close: 'Close'
    },
    accordion: {
      title: 'Declared damages and calculation method',
      base: 'Compensation basis',
      details: 'Compensation details',
      calcCompensation: 'How is this compensation calculated?'
    },
    amount: '{amount} €',
    actions: {
      primary: 'Yes, I accept the proposed compensation',
      secondary: 'I would like to discuss this valuation with an advisor',
      tertiary: 'No, I wanted another solution'
    },
    materialsList: 'List of equipment',
    upptecDossier: 'Furniture report',
    mobilier: {
      title: 'Furniture damages',
      solution: 'Solution:',
      text1: 'Receive immediate compensation',
      text2: 'Based on the description of your damages, we offer you the following immediate compensation:',
      text3: 'If you accept this compensation, you will receive it in the bank account used for your premium payments or by check.',
      text4: 'If you decline this compensation, an Allianz advisor will contact you within 48 hours*.',
      text5: '*Business hours and except in case of exceptional or unforeseen issues.',
      age: 'Age (in years):',
      actions: {
        primary: 'Accept this compensation',
        secondary: 'Decline this compensation'
      }
    }
  },
  damageFraisValidation: {
    title: 'Expenses related to the incident',
    solution: 'Solution:',
    text: 'Receive a reimbursement with proof',
    text1: 'Based on the description of your incurred expenses, we offer the following reimbursement with proof:',
    text2: 'If you accept this reimbursement, you will need to provide your proof directly from your Client Space.',
    text3: 'If you refuse this reimbursement, an Allianz advisor will contact you within 48 hours*.',
    text4: '*Working hours and except in case of exceptional or unforeseen issues.',
    actions: {
      primary: 'Accept this reimbursement',
      secondary: 'Refuse this reimbursement'
    }
  },
  // common
  common: {
    surface: 'Surface',
    line: 'Lineal',
    distance: 'Distance',
    actualCalc: 'Calculation in progress',
    selectOnTheMap: 'Select on map to measure',
    mapAction: 'Measure map',
    mapActionLine: 'Measure map',
    min: 'Minimum',
    max: 'Maximum',
    total: 'Total',
    recommended: 'Recommended',
    standard: 'Standard',
    noFile: 'No files selected',
    email: 'E-mail',
    search: 'Search',
    results: 'Results',
    noresults: {
      short: 'No results found',
      long: 'There are no results for your search'
    },
    true: 'Yes',
    false: 'No',
    noOptions: 'No option',
    noSelected: 'None selected.',
    agentView: 'Agent view',
    managerView: 'Manager view',
    unit: '0 of units | x {count} unit | x {count} of units'
  },

  // view: error
  errorView: {
    title: 'An error has occurred',
    text: 'Our team is working to resolve the problem as quickly as possible.'
  },

  timedoutView: {
    title: 'The link has expired',
    text: {
      upper: `We're sorry, but the link has expired and is no longer valid`,
      lower: `Contact our operators for a new link`
    }
  },

  // component: cart
  cart: {
    title: 'List of damages introduced'
  },

  // component: form-container
  formContainer: {
    mursTitle: 'Number of walls affected'
  },

  // component: customImage
  customImageInput: {
    default: {
      takeScreenshot: 'Frame the damage in the first guide',
      repeat: 'Repeat',
      usePhoto: 'Use photo'
    },
    guideCamera: {
      takeScreenshot: 'Frame the damage in the {guideIndexLiteral} guide',
      first: 'first',
      second: 'second',
      third: 'third'
    },
    cornersCamera: {
      takeScreenshot: 'From the center of the room, photograph every corner',
      endPhotos: 'Finalize'
    }
  },
  otpView: {
    title: 'Hello',
    text: {
      upper: `Welcome to your "My damages" space which allows you to describe the completeness of your damages.`,
      upper2: `To access it, please enter the code sent to your phone at `,
      upper3: `This step can take up to 2 minutes.`,
      lower1: `Please enter your verification code.`,
      lower2: `A code has been sent to your phone at `,
      nocode: `Didn't receive your code?`,
      resend: 'Resend an SMS',
      resendNotification: 'Forwarded message',
      errorNotification: 'Wrong code',
      popup: {
        text1: `If you have not received the authentication code, we recommend these three steps : `,
        list1_1: `Check that the phone number`,
        list1_2: `matches yours`,
        list2: `If the number matches, close this window and click on “Resend SMS”`,
        list3: `If the number does not correspond, we invite you to enter it on your `,
        link1: `Client area`,
        text2: `An Allianz adviser will call you back within 24 hours.`,
        bpce: {
          text3: 'If the number does not correspond, please contact your BPCEAI advisor.'
        }
      }
    },
    bpce: {
      title: 'Hello',
      upper1: 'Your quote/invoice will be processed by our team, and we will get back to you as soon as possible.'
    }
  },
  // legal conditions
  cookiesAndLegal: {
    general: {
      title: 'Terms and Conditions',
      paragraph1: `Before you begin, please review our use of cookies in your browser and our terms and conditions of service. By clicking on the Accept button, you confirm that you have read and understood the conditions relating to this service.`
    },
    cookies: {
      title: 'COOKIES POLICY',
      paragraph1: {
        list1: `You will then be shown the Cookies Policy (henceforth referred to as “the Cookies Policy” or “the Policy”) governing the Web Platform https://mavalue.plataforma-smart.com/ (henceforth referred to as “the Platform”, or “MAValue”), ownership of Multiassistance, S.A. (hereinafter referred to as “Multiassistance” or “we”).`,
        list2: `The purpose of this Cookies Policy is to help you understand the use made on this web platform of cookies, their types, their purpose and their duration and to also indicate to you the options you have to configure, administer or opt out of these.`,
        list3: `PLEASE TAKE A FEW MINUTES TO READ OUR COOKIES POLICY, IT WILL NOT TAKE YOU LONG. WE WANT TO EXPLAIN IN A SIMPLE, CLEAR AND TRANSPARENT WAY HOW WE PROCESS AND PROTECT YOUR PERSONAL INFORMATION AND YOUR RIGHTS. YOUR SECURITY AND THAT OF YOUR PERSONAL DATA IS FUNDAMENTAL TO US AND WE TAKE THEIR PROPER PROTECTION VERY SERIOUSLY.`,
        list4: `WE ALSO RECOMMEND THAT YOU READ OUR PRIVACY POLICY.`
      },
      paragraph2: {
        title: `What are cookies?`,
        body: `Cookies are small files or small devices downloaded and stored within your terminal (i.e. the device from which you access the Platform: the computer, the Mobile Phone, the Tablet or any other connected device…) and which allow the Platform or the website to remember information related to your visit.
        Cookies can be of different types depending on several parameters:`,
        list1: `Depending on the entity managing the team or domain from which the cookies are sent and where the data obtained is processed, we can distinguish the following:`,
        list2: `Cookies specific to us: these are those that are sent to the user's terminal equipment from equipment or a domain managed by Multiassistance and from which the service requested by the user.`,
        list3: `Third-party Cookies: these are those that are sent to the user's terminal equipment from equipment or a domain not managed by Multiassistance, but by another entity processing the data obtained by the cookies. When cookies are installed from equipment or a domain managed by Multiassistance, but the information collected by them is managed by a third party, they cannot be considered to be cookies specific to Multi-assistance. In this sense, Multiassistance may use the services of analysis and measurement companies to measure and/or analyze the browsing behavior of users on the platform, and, with this in mind, that they act on its behalf and in its representation, due to the analysis of the data obtained by the use of the cookies of these services, all with the aim of improving the service provided by Multiassistance.`,
        list4: `Depending on the purpose for which the data obtained through cookies are processed, we can distinguish between:`,
        list5: `Technical cookies: These are those that allow the user to navigate through the platform and use the different options or the different services available there such as, for example, traffic control and communication of data, identification of the session, access to restricted access data, reminder of the elements constituting a request for registration or participation in an event, the use of security elements during navigation , saving content for broadcasting videos or sound or sharing content in social networks.`,
        list6: `Personalization cookies: These are cookies allowing the user to access the service with certain predefined general characteristics according to a set of criteria on the user's terminal such as, for example, the language, the type of browser used to access the service, the regional configuration to access the service, among others.`,
        list7: `Analysis cookies: These are those allowing their manager to monitor and analyze the behavior of users of the websites to which they are attached. The information collected by means of this type of cookie is used to measure activity on the platform and for the development of user browsing profiles on the sites in question, on the applications and on the platforms with a view to place of improvements: based on the analysis of the data consulted by the users of the service.`,
        list8: `Advertising cookies: These are those allowing the management in the most efficient way possible, of the advertising spaces having been, if necessary, included by the publisher on a web page, an application or a platform to from which the requested service will be provided based on criteria such as edited content or display frequency of advertisements.`,
        list9: `Behavioral advertising cookies: These are those allowing the management, in the most efficient way possible, of the advertising spaces that the publisher, if necessary, would have included within a website, an application or platform from which the requested service will be provided. These cookies save information on user behavior that has been obtained through the continuous observation of their browsing habits, allowing the development of a specific profile based on it.`,
        list9_1: `Depending on the time period in which they are active within the terminal equipment (temporality), we can distinguish the following:`,
        list10: `Session cookies: These are cookies designed to collect and save data during the user's access to the platform.`,
        list11: `Persistent cookies: These are cookies where the data continues to be saved within the terminal and which can be processed during a period of time defined by the person responsible for the cookie, and which can vary from a few minutes several years.`,
        footer: `You can consult the information on cookies and other tracers provided by the Commission National de l'Informatique et Libertés (CNIL) by clicking here.`
      },
      paragraph3: {
        title: `What cookies are used on the platform?`,
        body: `This platform uses technical cookies necessary to enable and optimize user navigation and the functionality of the platform.
        The cookies used are necessary to allow navigation on the Platform and to ensure its proper functioning, therefore they cannot be refused by the user and the deactivation or cancellation of these will make it impossible to use the Platform. .
        Below, the cookies used within this Platform are identified: `,
        list1: `Cookies`,
        list1_1: `mavalue.plataforma-smart`,
        list2: `Purpose`,
        list2_1: `Cookie to keep you logged in`,
        list3: `Management`,
        list3_1: `Clean`,
        list4: `Duration`,
        list4_1: `1 year`
      },
      paragraph4: {
        title: `Updates and changes to the cookie policy.`,
        body: `This Cookies Policy may be modified according to legislative, regulatory requirements or having the purpose of adapting this policy to the instructions stipulated by the National Commission for Computing and Freedoms (CNIL), with this in mind we advise users to consult it periodically.`
      }
    },
    legal: {
      title: 'LEGAL NOTICE',
      paragraph1: {
        list1: `Access to the digital solutions and to all the functionalities contained within this Platform are included in the services contracted by the company which holds the right to use them (the company), on whose behalf you acquire the condition of user thereof. Accessing, browsing and using the Platform implies satisfying the condition of user thereof (from now on referred to as “the user”) and, therefore, subscribing to the express and unreserved acceptance by the user of all the terms and conditions contained in this Legal Notice, which is why we recommend its careful reading, so that in the event of disagreement, it would suffice not to accept it by the means provided for this purpose, a fact that makes it impossible to use the Platform, the services and the functionalities established through the latter.`
      },
      paragraph2: {
        title: `GENERAL INFORMATION.`,
        subParagraph1: {
          title: `EDITOR`,
          line1: `MULTIASSISTANCE, S.A. (Hereinafter referred to as “Multiassistance” or “we”); `,
          line2: `Limited company with capital of 48,494.10 euros`,
          line3: `146 boulevard de Charonne`,
          line4: `75020 Paris`,
          line5: `Intra-community VAT identification number: FR 62413114901`,
          line6: `Name of the Director of publication: Mr. Íñigo Astarloa Echevarrieta`,
          line7: `Tel: 01 40 09 36 60`,
          line8: `Email: info@multiasistencia.com; contact.clients@Multiassistance.com `
        },
        subParagraph2: {
          title: `HOSTER`,
          line1: `Amazon Web Services EMEA SARL`,
          line2: `38 avenue John F Kennedy, L-1855 Luxembourg`,
          line3: `Fax: 352 2789 0057`
        }
      },
      paragraph3: {
        title: `WEB PLATFORM: USE, PURPOSE AND APPLICABLE LEGAL REGIME.`,
        list1: `Multiassistance is a company specializing in the management and repair of claims in home and commercial insurance for insurance companies and, within the framework of this activity, it provides its customers with digital solutions aimed at optimizing and digitizing their operational processes.`,
        list2: `The Platform is the channel through which authorized users can use the different solutions that they have contracted or that the company to which they belong or with which they have a collaborative relationship has contracted. `,
        list3: `Access to the digital solutions and to all the functionalities contained within this Platform are included in the services contracted by the company which holds the right to use them (the company), on whose behalf you acquire the condition of user thereof. Access to and use of the Platform implies acceptance of all the present conditions, as well as any other conditions that may be established, modified and/or extended on the basis of certain present or future needs of the Service. Multiassistance will be entitled to modify at any time the content of these conditions as well as the services and functionalities established in the Platform while understanding that the publication of these changes in question and modifications by this means of communication will be sufficient, without however that this does not prejudice the possibility of the user to accept or not to accept the modifications in question. In the event of non-acceptance, this could result in the impossibility of using the Platform for all or certain functionalities stipulated by the latter.`
      },
      paragraph4: {
        title: `TERMS OF ACCESS AND USE.`,
        body1: `The user undertakes to make appropriate and lawful use of the Platform, as well as the contents, products and services established from it, in accordance with the applicable legislation at all times, under the present conditions , to the moral sense and generally accepted good habits as well as to public order. `,
        body2: `Furthermore, the user of the Platform agrees to the following:`,
        list1: `Guarantee the authenticity, veracity, updating and accuracy of all data communicated through the Platform, specifying that otherwise, the user will be solely responsible.`,
        list2: `Use the Platform exclusively for the purposes and functionalities agreed by Multiassistance, the user is thus prohibited from using the Platform for any other purpose or any other means.`,
        list3: `Make legal and legitimate use of the Platform, avoiding any unauthorized, fraudulent, illegal or illegitimate use of it and/or of the contents and information established by it, avoiding going to against these Legal Notices as well as the applicable regulations, to infringe the rights and legitimate interests of Multiassistance or any other third party that may be affected by this action.`,
        list4: `Do not cause damage to the physical or logical systems of the Platform, its suppliers or third parties; not to attempt to breach the security or authentication measures thereof, not to carry out actions causing disproportionate or unnecessary saturation of the infrastructure or the communications environment relating to the Platform and the Service, attacking the latter in one way or another. Multiassistance may implement any preventive or corrective measure deemed necessary to protect its interests in accordance with the correct functioning of the Platform, the Service and the specified functionalities.`,
        list5: `Do not introduce or disseminate on the network computer viruses or any other physical or logical system that may cause damage such as viruses, malicious code or any other harmful programs or archives.`,
        list6: `Do not attempt to access, use and/or manipulate data or any other information that is processed by the Platform.`,
        list7: `In particular, and for information only and not exhaustively, the user agrees not to transmit, disseminate or make available to third parties information, data, content or messages that may infringe the rights of Multi-assistance or third parties.`,
        list8: `Not to access without authorization or use a false identity, impersonate the identity of third parties or use a profile or carry out any other action which could generate confusion or mislead as to the correct identity of the user in question .`
      },
      paragraph5: {
        title: `INDUSTRIAL AND INTELLECTUAL PROPERTY.`,
        list1: `The user acknowledges and accepts that all intellectual and industrial property rights on the Platform and all its associated elements correspond to Multiassistance or to third parties having specifically authorized Multiassistance for this purpose.`,
        list2: `Under no circumstances does access to or navigation on the Platform imply any type of withdrawal, transmission, license or total or partial transfer of these rights in question, unless the contrary is expressly stipulated in writing .`,
        list3: `All intellectual and industrial property rights concerning the contents and/or services of the Platform are reserved and, in particular, it is prohibited to modify, copy, reproduce, communicate publicly, transform or distribute , by any means or in any format, all or part of the contents being included therein for public or commercial purposes, unless the prior, express and written authorization of the respective owners is obtained.`,
        list4: `The user going against these limitations and prohibitions acknowledges that he assumes exclusive responsibility, thereby releasing Multiassistance, or any other third party that may be affected by the action of the user from any responsibility.`
      },
      paragraph6: {
        title: `EXCLUSION OF WARRANTIES AND LIABILITY.`,
        list1: `Multiassistance will adopt several measures to protect the Platform and the contents against computer attacks by third parties. In any case, it is important that users are responsible for taking all appropriate technical measures to reasonably control the threats to which they are exposed, including updating systems for detecting malicious software, such as viruses, Trojans, etc. as well as security patches for affected browsers.`,
        list2: `The user is responsible for keeping his access codes safe and must avoid their use by unauthorized third parties and adopt the necessary security measures to maintain the confidentiality of the access and verification systems or codes established in connection with the Platform. Multiassistance declines all responsibility in the event of negligence, imprudence or misuse by the user or an unauthorized third party and shall in no case be liable for damages and prejudices that may arise from this unauthorized access.`,
        list3: `Multiassistance reserves the right to suspend, without prior notice, access to users who, in accordance with its criterion, do not comply with the rules of use of the Platform and, moreover, to exercise the relevant legal measures, without that this does not generate any right of compensation for the benefit of the user who may have been affected.`,
        list4: `Multiassistance declines all responsibility arising from damages and losses of any type that may arise from the use of the services and content by users, or that may arise from the lack of information, accuracy or veracity that these provide as part of the Platform and the Service. Under no circumstances can Multiassistance be held liable for the use that users and/or third parties make of the Platform, as well as for any damages and losses that may result therefrom.`
      },
      paragraph7: {
        title: `THE MODIFICATION OF THE LEGAL NOTICES.`,
        list1: `Multiassistance reserves the right to modify the information contained in these legal notices, in order to adapt them to future legislative, doctrinal or jurisprudential developments arising from the application, either for technical, operational, commercial, corporate and entrepreneurial, giving prior and reasonable notice to users of the changes taking place as soon as possible. In any case, it is recommended, each time you access the Platform, to carefully read the legal notices.`,
        list2: `In case of doubt relating to these legal notices, the user may contact Multiassistance by email at the following email address: info@multiasistencia.com`
      }
    },
    bpce: {
      general: {
        title: 'Cookie Usage',
        paragraph1: 'This website uses technical cookies to ensure its proper functioning.',
        title2: 'Privacy Policy',
        paragraph2: 'Multiassistance will process your personal data to manage your claim. At any time, you can exercise your right of access, rectification, deletion, as well as those provided by the GDPR. For more information, please consult ',
        policyText: 'our full privacy policy.',
        acceptText: 'I have read and accept the ',
        privacyText: 'Privacy Policy'
      },
      privacy: {
        title: 'Privacy Policy',
        paragraph1: 'MULTIASSISTANCE, S.A., with its registered office at 19 rue Emmy Noether, 93400 Saint-Ouen-sur-Seine (France), registered in the Bobigny Trade and Companies Register under number 413 114 901, informs you as the data controller that, through BillMA, we will process your personal data (identification data, insurance-related data, contact data, and financial data linked to your insurance) to manage and review the estimate associated with your claim, based on the execution of your insurance contract. In this regard, we inform you that your data has been communicated to us by BPCE Assurances IARD.',
        paragraph2: 'These data will be retained for the time strictly necessary to achieve the stated purpose and to comply with applicable legal obligations.',
        paragraph3: 'Similarly, we inform you that your data will not be transferred to third parties, except as required by law.',
        paragraph4: 'Finally, we inform you that you can exercise your rights of access, rectification, deletion, restriction of processing, data portability, or opposition by sending an email to ',
        paragraph5: 'If you believe that your rights have not been properly respected, you may file a complaint with the National Commission on Informatics and Liberties (',
        paragraph6: ') However, we recommend that before filing a complaint or claim, you contact our Data Protection Officer (',
        paragraph7: ') to analyze the specific situation and, if necessary, seek an effective and amicable solution.'
      }
    }
  },
  summary: {
    title: 'Summary',
    billma: {
      solution: 'Solution: Choose my own craftsman',
      text1: 'Your quote has been accepted.',
      text2: 'You will receive, as soon as possible, an initial payment of 50% of the total amount (including VAT) to begin the work with your contractor.',
      text3: 'The balance will be paid upon submission of the invoice, which you must send to us via your Client Area or the Mon Allianz mobile application.'
    },
    immobilier: {
      title: 'Property damages',
      ren: {
        compensation: 'Selected appointment',
        details: 'Functioning details',
        modal: {
          title: 'Functioning details',
          subtitle: 'The compensation you will receive for your property damages depends on:',
          list1: 'If you choose repair by an approved craftsman, you will select the date and time of the first appointment with the craftsman based on the proposed time slots. The craftsman will carry out all the work related to your property damages and coordinate with you if multiple interventions are required.',
          list2: 'Allianz will directly cover the repairs except for any deductible that remains your responsibility and must be paid directly to the craftsman at the end of their service.',
          confirm: 'Accept'
        },
        solution: 'Solution: Choose an Allianz-approved professional',
        text1: 'The professional will contact you within 48h* to confirm the date and time of your appointment.',
        text2: 'An Allianz repair service advisor is also available for any questions regarding your case.',
        phoneText: '(cost of a local call)'
      },
      franchise: {
        title: 'Deductible',
        subtitle: 'Deductible payable by the client'
      },
      billma: 'Accepted quote',
      gag: {
        compensation: 'Details of your compensation',
        indemnisation: 'Total amount',
        details: 'Reported damages',
        dommages: 'Internal damages',
        calcule: 'How is this compensation calculated?',
        modal: {
          title: 'How is this compensation calculated?',
          subtitle: 'The agreed compensation you will receive for your property damages is calculated based on the full repair cost. This cost includes materials, tool rentals, and compensation for time spent. If you accept this compensation, any deductible will be deducted from the total base.',
          confirm: 'Accept'
        },
        franchise: {
          title: 'Deductible',
          subtitle: 'Deductible payable by the client'
        },
        solution: 'Solution: Do the work myself'
      }
    },
    mobilier: {
      title: 'Furniture damages',
      subtitle: 'Details of your compensation',
      indemnisation: 'Total amount',
      details: 'Declared damages',
      total: 'Total compensation base',
      solution: 'Solution: Receive immediate compensation',
      description: 'You will receive, as soon as possible, the payment of your compensation allowing you to replace your damaged furniture.'
    },
    frais: {
      title: 'Expenses related to the claim',
      recherche: 'Leak detection',
      deplacement: 'Furniture movement',
      mise: 'Safety measures',
      provisorie: 'Temporary repair',
      gag: {
        title: 'Deductible',
        subtitle: 'Deductible payable by the client',
        total: 'Total compensation'
      },
      solution: 'Solution: Receive a refund with proof',
      description: 'To receive a refund for the incurred expenses as quickly as possible, please send us your proof directly from your Client Space, section "My procedures".'
    },
    confirm: 'Accept and finish'
  },
  textDescriptionError:
    'Please complete the description of the damage before continuing',
  stepper: {
    step3: 'Choice of the compensation solution',
    step4: 'Summary'
  }
}
